import React from "react";
import { Helmet } from "react-helmet-async";
import emailjs from "emailjs-com";
import ScrollToTopButton from '../components/ScrollToTopButton';
import { CONTACT_NUMBER } from '../components/Header';
import KAimg from '../assets/namma-bengaluru.png';
import TNimg from '../assets/KTN-pic.png';
import ANDimg from '../assets/Hyderabad-pic.png';
import DCimg from '../assets/NewDelhi.png';
const ContactUs = () => {
  const [form, setForm] = React.useState({ name: "",tel: "", city: "" ,email: "", message: ""});
  const [formStatus, setFormStatus] = React.useState("");
  const [formErrors, setFormErrors] = React.useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setFormErrors({ ...formErrors, [e.target.name]: "" });
  };

  const validate = () => {
    const errors = {};
    if (!form.name.trim()) errors.name = "Name is required";
    if (!form.tel.trim()) errors.name = "Contact number is required";
    if (!form.city.trim()) errors.name = "City name is required";
    if (!form.email.trim() || !/^\S+@\S+\.\S+$/.test(form.email))
      errors.email = "Valid email is required";
    if (!form.message.trim()) errors.message = "Message is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus("");
    const errors = validate();
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setFormStatus("Sending...");
    try {
      await emailjs.send(
        "service_wopctcd",
        "template_1bl6e3r",
        {
          from_name: form.name,
          contact_no: form.tel,
          city: form.city,
          from_email: form.email,
          message: form.message,
          to_email: "info@ev91riderz.com",
          time: new Date().toLocaleString(),          
        },
        "P1G-nYFTVU0tjs5KP"
      );
      setFormStatus("Message sent! We will contact you soon.");
      setForm({ name: "", tel: "", city: "",email: "", message: ""});
    } catch (err) {
      setFormStatus("Failed to send. Please try again later.");
    }
  };

  // FAQ data
  const faqList = [
    {
      question: "How can I become EV-91 delivery partner?",
      answer: (
        <p className="text-gray-700">You can become an EV-91 delivery partner by filling out our online application form or contacting us directly through the contact details provided above. Our team will guide you through the onboarding process.</p>
      ),
    },
    {
      question: "How much do I earn per order?",
      answer: (
        <p className="text-gray-700">You can earn between ₹35 to ₹55 per order, including incentives, surge pay, tips, and bonuses.</p>
      ),
    },
    {
      question: "How long does the delivery partner application process take?",
      answer: (
        <p className="text-gray-700">The application process typically takes around 1 hour to complete. You must have your Aadhaar card and PAN card, as they are compulsory for verification.</p>
      ),
    },
    {
      question: "How much distance does a delivery partner typically travel for each order?",
      answer: (
        <p className="text-gray-700">A delivery partner usually travels around 3 to 4.5 kilometers per order on average.</p>
      ),
    },
    {
      question: "What types of items can be delivered?",
      answer: (
        <p className="text-gray-700">Delivery partners can deliver a variety of items, including groceries, medicines, food, and other essential goods.</p>
      ),
    },
    {
      question: "How much does it cost to rent a scooter",
      answer: (
        <p className="text-gray-700">The vehicle rent is ₹180 per day, which totals ₹1260 per week.For further details, feel free to reach out to our support team.</p>
      ),
    },
     {
      question: "How can I cancel my order?",
      answer: (
        <p className="text-gray-700">Please reach out to the seller directly or follow the guidelines mentioned on their official website.</p>
      ),
    },
  ];

  const [openIndex, setOpenIndex] = React.useState(null);

  return (
    <>
      <Helmet>
        <title>Contact Us | EV91Technologies</title>
        <meta
          name="description"
          content="Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions."
        />
        <meta
          name="keywords"
          content="Contact, EV91, VOICE, support, business, electric vehicles, logistics"
        />
        <meta property="og:title" content="Contact Us | EV91Technologies" />
        <meta
          property="og:description"
          content="Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions."
        />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/contact-us" />
        <link rel="canonical" href="https://ev91riderz.com/contact-us" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us | EV91Technologies",
            "description": "Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions.",
            "url": "https://ev91riderz.com/contact-us"
          }
        `}</script>
      </Helmet>

      <section className="relative -mt-6 overflow-hidden bg-slate-950 px-5 py-20 text-white lg:px-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(190,242,100,0.18),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.2),transparent_40%)]"></div>
        <div className="relative mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1fr_0.95fr] lg:items-center">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.26em] text-lime-300">Contact EV91</p>
            <h1 className="mt-4 text-4xl font-black tracking-tight md:text-6xl">
              Talk to the team powering electric last-mile operations.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              Reach us for rider onboarding, EV rental, 3PL logistics, city launches, or enterprise partnerships.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={`tel:${CONTACT_NUMBER.replace(/\s+/g, '')}`} className="rounded-full bg-lime-300 px-7 py-3 font-black text-slate-950 transition hover:-translate-y-0.5 hover:bg-white">
                Call EV91
              </a>
              <a href="#FAQ" className="rounded-full border border-white/15 bg-white/20 px-7 py-3 font-black text-white backdrop-blur transition hover:bg-white hover:text-slate-950">
                View FAQs
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              [KAimg, "Bengaluru"],
              [TNimg, "Chennai"],
              [ANDimg, "Hyderabad"],
              [DCimg, "New Delhi"],
            ].map(([image, city]) => (
              <div key={city} className="overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/8 shadow-xl shadow-black/20">
                <img src={image} alt={`${city} EV91 office`} className="h-40 w-full object-cover" />
                <div className="p-4 text-sm font-black text-lime-100">{city}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hidden">
  {/* Background Blurs */}
  <div className="absolute -top-20 -left-20 w-80 h-80 bg-green-400 opacity-25 rounded-full blur-3xl animate-pulse" />
  <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-lime-400 opacity-20 rounded-full blur-2xl animate-ping" />

  {/* Content Card */}
  <div className="relative z-10 max-w-4xl mx-auto text-center backdrop-blur-md bg-white/10 p-6 rounded-3xl border border-white/10 shadow-xl">
    <h1 className="text-4xl md:text-5xl font-extrabold text-lime-300 mb-4 tracking-tight">
      📬 Contact Us
    </h1>
    <p className="text-lg md:text-xl text-gray-200 mb-6">
      Have a question or need support? We’re here to help with all your electric mobility, logistics, and rental needs.
    </p>
    <a
      href="#FAQ"
      className="inline-block bg-white text-green-800 font-semibold px-6 py-3 rounded-full shadow-md hover:bg-green-100 hover:scale-105 transition-transform duration-200"
    >
      🤔📘 Got Questions?
    </a>
  </div>
</section>


     <section className="bg-slate-50 py-16">
  <div className="container mx-auto px-4 max-w-6xl">
    <div className="flex flex-col md:flex-row items-start justify-center gap-8">
      {/* Enquiry Form */}
      <div className="md:w-5/12 w-full bg-white p-8 rounded-[2rem] shadow-2xl shadow-slate-900/10 border border-emerald-100 relative overflow-hidden">
  {/* Gradient Background Orbs */}
  <div className="absolute -top-20 -left-20 w-52 h-52 bg-gradient-to-br from-green-300 via-green-200 to-white opacity-40 rounded-full blur-3xl animate-pulse-slow"></div>
  <div className="absolute -bottom-20 -right-20 w-52 h-52 bg-gradient-to-tr from-green-500 via-green-300 to-white opacity-30 rounded-full blur-3xl animate-pulse-slow"></div>

  <div className="relative z-10">
    <h2 className="text-3xl font-extrabold mb-6 text-green-800 text-center">
      📩 Enquiry Form
    </h2>

    <form autoComplete="on" name="contact" onSubmit={handleSubmit}>
      {[
        { label: "Name", type: "text", name: "name", auto: "name" },
        { label: "Contact Number", type: "tel", name: "tel", auto: "tel" },
        { label: "City", type: "text", name: "city", auto: "address-level2" },
        { label: "Email", type: "email", name: "email", auto: "email" },
      ].map((field) => (
        <div className="mb-5 relative" key={field.name}>
          <label className="block text-gray-700 font-medium mb-1">{field.label}</label>
          <input
            type={field.type}
            name={field.name}
            autoComplete={field.auto}
            value={form[field.name]}
            onChange={handleChange}
            required
            className={`w-full px-4 py-3 rounded-2xl bg-green-50/50 backdrop-blur-md border ${
              formErrors[field.name] ? "border-red-500" : "border-green-200"
            } focus:ring-2 focus:ring-green-400 focus:outline-none shadow-inner transition-all duration-300`}
          />
          {formErrors[field.name] && (
            <p className="text-red-500 text-xs mt-1">{formErrors[field.name]}</p>
          )}
        </div>
      ))}

      <div className="mb-5">
        <label className="block text-gray-700 font-medium mb-1">Message</label>
        <textarea
          name="message"
          rows="4"
          value={form.message}
          onChange={handleChange}
          required
          className={`w-full px-4 py-3 rounded-2xl bg-green-50/50 backdrop-blur-md border ${
            formErrors.message ? "border-red-500" : "border-green-200"
          } focus:ring-2 focus:ring-green-400 focus:outline-none shadow-inner transition-all duration-300`}
        ></textarea>
        {formErrors.message && (
          <p className="text-red-500 text-xs mt-1">{formErrors.message}</p>
        )}
      </div>

      <button
        type="submit"
        disabled={formStatus === "Sending..."}
        className="w-full py-3 rounded-full bg-gradient-to-r from-green-600 to-green-400 text-white font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300 animate-pulse-slow"
      >
        {formStatus === "Sending..." ? "Sending..." : "Submit"}
      </button>

      {formStatus && (
        <p
          className={`text-center mt-3 font-medium ${
            formStatus.includes("sent") ? "text-green-600" : "text-red-500"
          }`}
        >
          {formStatus}
        </p>
      )}
    </form>
  </div>
</div>

      {/* Contact Info & Map */}
<div className="md:w-7/12 w-full mt-8 md:mt-0 relative rounded-[2rem] overflow-hidden shadow-2xl shadow-slate-900/10 border border-emerald-100 bg-white">
  {/* Floating Background Orbs */}
  <div className="absolute -top-24 -right-24 w-64 h-64 bg-gradient-to-br from-green-300 via-green-100 to-white opacity-40 rounded-full blur-3xl animate-pulse-slow"></div>
  <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-gradient-to-tr from-green-400 via-green-200 to-white opacity-30 rounded-full blur-3xl animate-pulse-slow"></div>

  <div className="relative z-10 p-6 md:p-8">
    <h2 className="text-3xl font-extrabold mb-6 text-green-800 text-center md:text-left drop-shadow-md">
      📍 Contact Information
    </h2>

    <div className="flex flex-col gap-5">
      {/* Email */}
      <div className="flex items-center gap-3 text-gray-700 group hover:text-green-700 transition-colors duration-300">
        <span className="text-green-700 text-2xl animate-bounce">📧</span>
        <span className="text-lg">
          <strong>Email:</strong>{" "}
          <a href="mailto:info@ev91riderz.com" className="underline hover:text-green-800">
            info@ev91riderz.com
          </a>
        </span>
      </div>

      {/* Phone */}
      <div className="flex items-center gap-3 text-gray-700 group hover:text-green-700 transition-colors duration-300">
        <span className="text-green-700 text-2xl animate-bounce delay-200">📞</span>
        <span className="text-lg">
          <strong>Phone:</strong>{" "}
          <a
            href={`tel:${CONTACT_NUMBER.replace(/\s+/g, '')}`}
            className="underline hover:text-green-800"
          >
            {CONTACT_NUMBER}
          </a>
        </span>
      </div>
    </div>

    {/* Map Card */}
    <div className="mt-6 rounded-3xl overflow-hidden shadow-xl border border-green-200 relative hover:scale-[1.02] transition-transform duration-500">
      <iframe
        title="EV91 Location Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.463313099236!2d77.61818277358732!3d12.877902416928672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae6b007e8a4499%3A0x5bad5610f34d02dd!2sEV91Technologies%20Warehouse%20Bengaluru!5e0!3m2!1sen!2sin!4v1773230385430!5m2!1sen!2sin"
        width="100%"
        height="300"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
        className="rounded-3xl"
      ></iframe>

      {/* Floating pin icon */}
      <div className="absolute -top-4 -right-4 bg-green-500 rounded-full w-10 h-10 flex items-center justify-center shadow-lg animate-bounce">
        <span className="text-white text-xl">📍</span>
      </div>
    </div>
  </div>
</div>
 {/* closes .md:w-7/12 ... */}
        </div> {/* closes .flex ... */}
      </div> {/* closes .container ... */}
    </section>

    <section className="relative py-24 bg-white overflow-hidden">
  {/* Background glowing shapes */}
  <div className="absolute -top-32 -left-32 w-96 h-96 bg-green-300/20 rounded-full blur-3xl animate-pulse-slow"></div>
  <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-green-400/20 rounded-full blur-3xl animate-pulse-slow"></div>

  <div className="container mx-auto px-4 relative z-10">
    <h2 className="text-4xl md:text-5xl font-extrabold text-center text-green-800 mb-16 drop-shadow-lg">
      🔹 Contact VOICE — We’re Here!
      <span className="block w-32 h-1 mx-auto mt-3 bg-gradient-to-r from-green-400 to-green-700 rounded-full animate-pulse"></span>
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[
        {
          icon: "📞",
          title: "Give Us a Call",
          desc: "Reach us at +91 90809 73764 (Mon–Sat, 10:00 AM–6:30 PM IST). Let's talk logistics, rentals, or partnerships."
        },
        {
          icon: "📍",
          title: "Visit Our Office",
          desc: "373/6, Begur - Hulimavu Rd, Classic Layout, Devarachikkana Halli, Bengaluru, Karnataka 560114"
        },
        {
          icon: "📅",
          title: "Availability Hours",
          desc: "We’re available Monday to Saturday, 10:00 AM–6:30 PM. Quick responses, friendly faces—always here for you."
        },
        {
          icon: "📱",
          title: "Follow Us",
          desc: "Stay updated on LinkedIn, X, and Instagram. DM us or tag @EV91 for quick replies."
        },
        {
          icon: "📄",
          title: "Resources & FAQs",
          desc: "Looking for fast answers? Explore our FAQ section and blog for delivery, EV rental & logistics insights."
        },
        {
          icon: "🚀",
          title: "Join Our Mission",
          desc: "Want to work with us? Visit life@voice — we’re hiring across India."
        }
      ].map((item, idx) => (
        <div
          key={idx}
          className="group relative overflow-hidden rounded-[2rem] border border-emerald-100 bg-white p-7 shadow-xl shadow-slate-900/8 transition hover:-translate-y-1 hover:shadow-2xl"
          style={{
            animationDelay: `${idx * 0.2}s`, // Staggered fall
          }}
        >
          <div className="absolute right-0 top-0 h-24 w-24 rounded-bl-[2rem] bg-slate-950 transition group-hover:bg-emerald-700"></div>
          <div className="absolute right-5 top-5 text-sm font-black text-lime-300">
            0{idx + 1}
          </div>
          <div className="relative mb-6 grid h-14 w-14 place-items-center rounded-2xl bg-emerald-50 text-3xl text-emerald-800 shadow-inner">
            <span>{item.icon}</span>
          </div>
          <h3 className="relative text-2xl font-black text-slate-950 mb-3">{item.title}</h3>
          <p className="relative text-slate-600 text-base leading-7">{item.desc}</p>
          <div className="mt-6 h-1 w-16 rounded-full bg-gradient-to-r from-emerald-500 to-lime-300 transition-all group-hover:w-28"></div>
        </div>
      ))}
    </div>
  </div>

  {/* Animations */}
  <style>{`
  @keyframes fallWobble {
    0% {
      transform: translateY(-200px) rotate(0deg);
      opacity: 0;
    }
    50% {
      transform: translateY(20px) rotate(5deg);
      opacity: 0.6;
    }
    70% {
      transform: translateY(-10px) rotate(-3deg);
      opacity: 0.8;
    }
    100% {
      transform: translateY(0) rotate(0deg);
      opacity: 1;
    }
  }

  @keyframes continuousWobble {
    0% { transform: translateY(0) rotate(0deg); }
    25% { transform: translateY(3px) rotate(2deg); }
    50% { transform: translateY(0) rotate(0deg); }
    75% { transform: translateY(-3px) rotate(-2deg); }
    100% { transform: translateY(0) rotate(0deg); }
  }

  .animate-fall {
    animation: fallWobble 1.5s ease-out forwards, continuousWobble 2s ease-in-out 1.5s infinite;
  }
`}</style>

</section>



      {/* FAQ Section */}
<section className="relative py-24 bg-slate-50" id="FAQ">
  <div className="container mx-auto px-6 max-w-7xl">
    <p className="text-center text-sm font-black uppercase tracking-[0.24em] text-emerald-700">Support Desk</p>
    <h1 className="mt-3 text-4xl font-extrabold text-center text-slate-950 mb-16 tracking-tight">
      ❓ Frequently Asked Questions
    </h1>

    {/* Timeline Wrapper */}
    <div className="relative max-w-4xl mx-auto space-y-12">
      {/* Vertical line in center */}
      <div className="absolute left-1/2 hidden h-full w-1 -translate-x-1/2 rounded bg-gradient-to-b from-slate-950 via-emerald-500 to-lime-300 opacity-30 md:block"></div>

      {faqList.map((faq, idx) => {
        const isOpen = openIndex === idx;
        const side = idx % 2 === 0 ? 'left' : 'right'; // alternate sides
        return (
          <div
            key={faq.question}
            className={`relative flex ${side === 'left' ? 'justify-start' : 'justify-end'} group`}
          >
            {/* Circle Indicator */}
            <div className="absolute left-0 top-6 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-slate-950 font-black text-lime-300 shadow-lg md:left-1/2 md:-translate-x-1/2">
              {idx + 1}
            </div>

            {/* FAQ Card */}
            <div
              className={`relative w-full rounded-[1.5rem] border border-emerald-100 bg-white p-6 pl-14 shadow-xl shadow-slate-900/8 transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl md:w-5/12 md:pl-6 ${
                side === 'left' ? 'ml-0 md:mr-auto' : 'ml-0 md:ml-auto'
              }`}
            >
              <button
                onClick={() => setOpenIndex(isOpen ? null : idx)}
                className="flex items-start w-full text-left gap-3"
              >
                <span className="text-green-600 text-2xl mt-1 animate-pulse">📌</span>
                <div>
                  <h2 className="text-lg font-black text-slate-950 group-hover:text-emerald-700 transition-colors duration-200">
                    {faq.question}
                  </h2>
                  <div
                    className={`mt-2 text-slate-600 transition-all duration-500 ease-in-out overflow-hidden ${
                      isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <p className="pt-2 text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                </div>
              </button>

              {/* Glow Line */}
              {isOpen && (
                <div className="absolute -bottom-4 left-4 right-4 h-1 rounded-full bg-gradient-to-r from-green-400 via-emerald-500 to-green-700 animate-pulse" />
              )}
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>

      {/* Rider Joining form */}
      {/* Locations Section - SEO rich */}
<section className="relative py-24 bg-gradient-to-br from-green-50 via-white to-green-100 overflow-hidden">
  {/* Glowing Energy Backgrounds */}
  <div className="absolute -top-32 -left-32 w-[500px] h-[500px] bg-green-400/20 rounded-full blur-[180px] animate-pulse"></div>
  <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-lime-300/20 rounded-full blur-[200px] animate-float-slow"></div>

  {/* Animated Gradient Grid Overlay */}
  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(34,197,94,0.15)_1px,_transparent_1px)] bg-[length:20px_20px] opacity-40 animate-grid-move"></div>

  <div className="relative z-10 container mx-auto px-6 lg:px-12">
    <h2 className="text-5xl lg:text-6xl font-extrabold text-center text-green-900 drop-shadow-[0_4px_12px_rgba(34,197,94,0.3)] mb-16 tracking-tight animate-wobble">
      🌍 Where EV91 Lives 🗺️
    </h2>

    {/* Location Cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
      {[
        {
          name: "Silicon Street 🏙️",
          city: "Bengaluru",
          link: "https://maps.app.goo.gl/z2Kg8Y4XBjrrmaQZA",
          address: "373/6, Begur - Hulimavu Rd, Classic Layout, Devarachikkana Halli, Bengaluru, Karnataka 560114",
          image: KAimg,
        },
        {
          name: "Bayline Station 🌊",
          city: "Chennai",
          link: "https://maps.app.goo.gl/EosRRawV3tBKadGYA",
          address: "Chennai - Address:EV91TECHNOLOGIES PVT LTD.5/442 Mariamman Kovil Main road ,S. Kolathur , Kovilambakkam Pin Code - 600129",
          image: TNimg,
        },
        {
          name: "Pearl Grid 🕌",
          city: "Hyderabad",
          link: "https://maps.app.goo.gl/sKMmG9gZQzKxB6D7A",
          address: "No. 6-3-1177/A/40 B.S Maqta, Kundabagh, Begumpet, Hyderabad, Telangana - 500016",
          image: ANDimg,
        },
        {
          name: "Capital Pulse 🏛️",
          city: "New Delhi",
          link: "https://maps.app.goo.gl/EVna98eLo2s9HTXZ7",
          address: "25, Pole no. 247, Near Hanuman Mandir, Chandan Hola Village, Chattarpur, New Delhi - 110074",
          image: DCimg,
        },
      ].map((loc, idx) => (
                <a href={loc.link} target="_blank" rel="noopener noreferrer" key={idx} className="block">
            <div
              
              className="group h-full overflow-hidden rounded-[2rem] border border-emerald-100 bg-white shadow-xl shadow-slate-900/8 transition duration-300 hover:-translate-y-1 hover:shadow-2xl"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={loc.image}
                  alt={`${loc.city}`}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-slate-950/15 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-xs font-black uppercase tracking-[0.18em] text-lime-300">{loc.name}</p>
                  <h3 className="mt-1 text-2xl font-black text-white">{loc.city}</h3>
                </div>
              </div>
              <div className="flex flex-grow flex-col p-5">
                <p
                  className="mb-4 inline-flex w-fit rounded-full bg-emerald-50 px-4 py-2 text-sm font-black text-emerald-800 group-hover:bg-slate-950 group-hover:text-lime-300"
                >
                  View on Map
                </p>
                <address className="text-slate-600 text-sm not-italic leading-relaxed">
                  {loc.address}
                </address>
              </div>
            </div>
        </a>
      ))}
    </div>

    {/* Climax Floating CTA */}
    <div className="mt-24 relative overflow-hidden rounded-[2rem] bg-slate-950 p-8 text-left text-white shadow-2xl md:p-10">
      {/* Glowing Orb Layer */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 left-1/4 w-24 h-24 bg-green-400/40 rounded-full blur-[60px] animate-float"></div>
        <div className="absolute bottom-0 right-1/3 w-32 h-32 bg-lime-500/30 rounded-full blur-[70px] animate-float-slow"></div>
      </div>

      <div className="relative grid gap-8 lg:grid-cols-[1fr_0.8fr] lg:items-center">
        <div>
          <p className="text-sm font-black uppercase tracking-[0.24em] text-lime-300">Expansion Desk</p>
          <h3 className="mt-3 text-3xl font-black md:text-5xl">Want EV91 in your city or business network?</h3>
          <p className="mt-4 max-w-2xl leading-8 text-slate-300">
            Talk to us for city launches, fleet partnerships, EV rental hubs, rider sourcing, and enterprise last-mile delivery operations.
          </p>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          {["New hub setup", "Fleet partnership", "Rider onboarding", "Enterprise logistics"].map((item) => (
            <div key={item} className="rounded-2xl border border-white/10  p-4 text-center font-black text-lime-100">
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* Keyframes */}
  <style>{`
    @keyframes float {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-15px); }
    }
    @keyframes float-slow {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-25px); }
    }
    @keyframes wobble {
      0%, 100% { transform: rotate(0deg); }
      25% { transform: rotate(1deg); }
      50% { transform: rotate(-1deg); }
      75% { transform: rotate(1deg); }
    }
    @keyframes grid-move {
      0% { background-position: 0 0; }
      100% { background-position: 40px 40px; }
    }
    .animate-float { animation: float 4s ease-in-out infinite; }
    .animate-float-slow { animation: float-slow 6s ease-in-out infinite; }
    .animate-wobble { animation: wobble 3s ease-in-out infinite; }
    .animate-wobble-slow { animation: wobble 6s ease-in-out infinite; }
    .animate-grid-move { animation: grid-move 10s linear infinite; }
  `}</style>
</section>



    <ScrollToTopButton />
    </> // closes React fragment
  ); // closes ContactUs component
};

export default ContactUs;
